import { QueryClient, QueryCache, MutationCache } from '@tanstack/react-query'
import { captureError } from '@/lib/sentry'
import { toError } from '@/lib/supabase'

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      captureError(toError(error, 'Query failed'), {
        queryKey: JSON.stringify(query.queryKey),
      })
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      captureError(toError(error, 'Mutation failed'), {
        mutationKey: mutation.options.mutationKey
          ? JSON.stringify(mutation.options.mutationKey)
          : 'unknown',
      })
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      refetchOnWindowFocus: false,
      networkMode: 'always', // Don't pause queries when offline
    },
  },
})
